import React, { useEffect, useContext, useState } from 'react';
import { FilterContext } from './FilterContext';
import axios from 'axios';
import config from '../../config';
import Select from 'react-select';

const Filters = ({ pageSpecificFilters }) => {
  const {
    filters,
    setFilters,
    selectedFilters,
    setSelectedFilters,
    updateFilters,
    resetFilters,
    DisplayFiltersName,
    setDisplayFiltersName,
  } = useContext(FilterContext);

  const [filteredOptions, setFilteredOptions] = useState({});
  const [pendingFilters, setPendingFilters] = useState({});  // New state for Apply functionality
  const [SelectedOptionsState, setSelectedOptionsState] = useState();

  useEffect(() => {
    if (!filters[pageSpecificFilters]) {
      axios
        .get(`${config.API_BASE_URL}/api/filters`, {
          params: { filterType: pageSpecificFilters },
        })
        .then((response) => {
          const filterData = response.data;

          setFilters((prev) => ({
            ...prev,
            [pageSpecificFilters]: filterData,
          }));

          Object.values(filterData).forEach((group) => {
            const selectedValues = group.values
              .filter((value) => Boolean(value.selected))
              .map((value) => value.value);

            if (selectedValues.length > 0) {
              const variableName = group.variable_name;
              if (variableName) {
                setPendingFilters((prev) => ({
                  ...prev,
                  [variableName]: selectedValues,
                }));
                updateFilters(variableName, selectedValues);
              }
            }
          });
        })
        .catch((err) => console.error('Error fetching filters:', err));
    }
  }, [pageSpecificFilters]);

  useEffect(() => {
    // You can use DisplayFiltersName here
    // console.log('Current Display Filters:', DisplayFiltersName);
  }, [DisplayFiltersName]);


  const handleReset = () => {
    resetFilters(pageSpecificFilters);
    setFilters((prev) => ({ ...prev, [pageSpecificFilters]: {} }));
    setPendingFilters({});
    window.location.reload();
  };

  // Track updates to pendingFilters and trigger re-render
  useEffect(() => {
    // This will trigger re-render whenever pendingFilters is updated
    // console.log("Pending Filters Updated:", pendingFilters);
  }, [pendingFilters]);


  const handleFilterChange = (variableName, selectedOptions, displayName) => {
    const selectedValues = selectedOptions?.map((option) => option.value) || [];
    const selectedOptionsId = selectedOptions?.map((option) => option.id).filter((id) => id !== undefined) || [];


    setPendingFilters((prev) => ({
      ...prev,
      [variableName]: selectedValues
    }));

    setDisplayFiltersName((prev) => ({
      ...prev,
      [displayName]: {
        [variableName]: selectedValues
      }
    }));


    setSelectedOptionsState((prevState = {}) => {
      const prevSelected = prevState?.[variableName] || [];
      const updatedSelection = prevSelected.filter(id => selectedOptionsId.includes(id));

      return {
        ...prevState,
        [variableName]: updatedSelection,
      };
    });


    setFilteredOptions((prev) => {
      const updatedFilteredOptions = { ...prev };

      Object.values(filters[pageSpecificFilters]).forEach((group) => {

        if (group.parent_group_id && group.parent_group_id !== 0) {
          const parentGroup = Object.values(filters[pageSpecificFilters]).find(
            (parent) => parent.id === group.parent_group_id
          );

          if (parentGroup) {
            const parentSelectedValues = selectedOptionsId || [];

            if (!updatedFilteredOptions[group.variable_name]) {
              updatedFilteredOptions[group.variable_name] = [...(prev[group.variable_name] || [])];
            }

            let newSubBrands = group.values.filter((value) =>
              parentSelectedValues.includes(Number(value.parent_id))
            );


            if (newSubBrands.length > 0 && parentSelectedValues.length > 0) {
              updatedFilteredOptions[group.variable_name] = newSubBrands;
            }
            else if (parentSelectedValues.length == 0 && newSubBrands.length < 0) {
              updatedFilteredOptions[group.variable_name] = [...group.values];
            }
            // console.log("Updated Sub-Brands for", group.variable_name, updatedFilteredOptions[group.variable_name]);
          }
        }
      });

      // console.log("Final Updated Filtered Options:", updatedFilteredOptions);
      return updatedFilteredOptions;
    });

    // Get all sub-brands from filters
    const allSubBrands = Object.values(filters[pageSpecificFilters])
      .flatMap(group => group.values)
      .filter(value => value.parent_id !== undefined);

    const updatedSubBrands = allSubBrands.filter(sb => selectedOptionsId.includes(sb.parent_id));

    // console.log("Updated Sub-Brands:", updatedSubBrands);

    setFilters((prevFilters) => {
      const updatedFilters = { ...prevFilters };

      if (variableName && updatedFilters[pageSpecificFilters]?.[variableName]) {
        updatedFilters[pageSpecificFilters][variableName].values =
          updatedFilters[pageSpecificFilters][variableName].values.map(value => ({
            ...value,
            selected: selectedValues.includes(value.value) ? 1 : 0
          }));
      }

      // console.log("Final Updated Filters:", updatedFilters);
      return updatedFilters;
    });


  };
  const handleFilterChangeNew = (variableName, selectedOptions, displayName) => {
    const variableNamesArray = Array.isArray(variableName) ? variableName : [variableName];

    const newState = {};

    variableNamesArray.forEach((varName) => {
      const selectedValues = selectedOptions
        .filter((option) => option.variableName === varName)
        .map((option) => option.value);

      if (selectedValues.length > 0) {
        newState[varName] = selectedValues;
      } else {
        newState[varName] = [];
      }
    });

    // console.log("New State Before Setting:", newState);

    // Step 1: Update selected options state
    setSelectedOptionsState((prevState) => {
      const prevStateSafe = prevState || {};
      if (JSON.stringify(prevStateSafe) !== JSON.stringify(newState)) {
        // console.log("State is being updated with new selections:", newState);
        return newState;
      }
      return prevStateSafe;
    });

    // Step 2: Ensure selectedFilters only retains valid 'SubCat_' options
    setFilters((prevFilters) => {
      const updatedFilters = { ...prevFilters };
      const newSelectedFilters = { ...selectedFilters };

      const validSubCatKeys = new Set(selectedOptions.map(opt => opt.variableName));

      Object.keys(newSelectedFilters).forEach((key) => {
        // if (key.startsWith("SubCat_") && !validSubCatKeys.has(key)) {
        if (
          (key.startsWith("SubCat_") || key.startsWith("Brand_")) &&
          !validSubCatKeys.has(key)
        ) {
          delete newSelectedFilters[key];

          // ✅ Correct way to update pendingFilters
          setPendingFilters((prevPendingFilters) => {
            const updatedPending = { ...prevPendingFilters };
            delete updatedPending[key];
            return updatedPending;
          });
        }
      });

      return updatedFilters;
    });


    // Step 3: Update filters (removing old selections) only if there are changes
    variableNamesArray.forEach((varName) => {
      const currentValues = newState[varName] || [];
      const previousValues = (SelectedOptionsState && SelectedOptionsState[varName]) || [];

      if (JSON.stringify(currentValues) !== JSON.stringify(previousValues)) {
        // console.log(`Updating filter for: ${varName} with selected values: ${currentValues}`);
        setPendingFilters((prev) => ({
          ...prev,
          [varName]: currentValues
        }));
        setDisplayFiltersName((prev) => {
          // Preserve previous display names and add or update the current one
          const newDisplayFilters = { ...prev };

          // Check if the display name already exists, then update its values
          if (newDisplayFilters[displayName]) {
            newDisplayFilters[displayName][varName] = currentValues;
          } else {
            newDisplayFilters[displayName] = { [varName]: currentValues };
          }

          // console.log("Updated DisplayFiltersName:", newDisplayFilters);
          return newDisplayFilters;
        });

        //setPendingFilters(varName, currentValues);
      } else {
        // console.log(`No change in filter for: ${varName}, skipping update.`);
      }
    });

    // Step 4: Update filtered options
    setFilteredOptions(() => {
      const updatedFilteredOptions = {};

      variableNamesArray.forEach((varName) => {
        Object.values(filters[pageSpecificFilters]).forEach((group) => {
          if (group.parent_group_id && group.parent_group_id !== 0) {
            const parentGroup = Object.values(filters[pageSpecificFilters]).find(
              (parent) => parent.id === group.parent_group_id
            );

            if (parentGroup) {
              const parentSelectedValues = selectedOptions
                .filter((option) => option.variableName === parentGroup.variable_name)
                .map((option) => option.id) || [];

              let newSubBrands = group.values.filter((value) =>
                parentSelectedValues.includes(Number(value.parent_id))
              );

              updatedFilteredOptions[group.variable_name] =
                newSubBrands.length > 0 && parentSelectedValues.length > 0
                  ? newSubBrands
                  : [...group.values];
            }
          }
        });
      });

      return updatedFilteredOptions;
    });

    // Step 5: Update Filters with the selected values
    setFilters((prevFilters) => {
      const updatedFilters = { ...prevFilters };

      variableNamesArray.forEach((varName) => {
        if (varName && updatedFilters[pageSpecificFilters]?.[varName]) {
          updatedFilters[pageSpecificFilters][varName].values =
            updatedFilters[pageSpecificFilters][varName].values.map(value => ({
              ...value,
              selected: newState[varName]?.includes(value.value) ? 1 : 0
            }));
        }
      });

      return updatedFilters;
    });
  };
  useEffect(() => {
    setPendingFilters(selectedFilters);
    // If 'trans_year' is found in selectedFilters, update DisplayFiltersName as well
    if (selectedFilters?.trans_year) {
      setDisplayFiltersName((prev) => ({
        ...prev,
        trans_year: selectedFilters.trans_year, // Set trans_year in DisplayFiltersName
      }));
    }
  }, [selectedFilters]);

  const handleApplyFilters = () => {
    setSelectedFilters(pendingFilters); // ✅ Updates `selectedFilters` on Apply
    Object.entries(pendingFilters).forEach(([variableName, selectedValues]) => {
      updateFilters(variableName, selectedValues); // ✅ Calls `updateFilters`
    });
  };

  const formatOptions = (values) => {
    return values
      .filter((value) => value.visible === 1)
      .sort((a, b) => a.sortOrder - b.sortOrder)
      .map((value) => ({
        label: value.label,
        value: value.value,
        id: value.id,
        variableName: value.variable_name || 'Default',
      }));
  };

  const currentFilters = filters[pageSpecificFilters] || {};
  const sortedGroups = Object.values(currentFilters).sort((a, b) => a.sortOrder - b.sortOrder);

  return (
    <div className="filters">
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h3>Filters</h3>
        <button
          className="filter-button apply-button"
          onClick={handleApplyFilters}  // ✅ Correctly triggers Apply logic
          style={{ marginLeft: '10px', margin: '5px' }}
        >
          Apply Filters
        </button>
        <button className="filter-button"
        style={{ marginLeft: '10px', margin: '5px' }} onClick={handleReset}>
          Reset Filters
        </button>
      </div>

      {Object.keys(currentFilters).length === 0 ? (
        <p>Loading filters...</p>
      ) : (
        sortedGroups.map((group, index) => {
          const groupVars = group.variable_name.includes(",")
            ? group.variable_name.split(",")
            : [group.variable_name];

          return (
            <div key={group.id || group.variable_name || index} style={{ marginBottom: '4%' }}>
              <label style={{ margin: '2%', display: 'block' }}>
                {group.displayName || 'Filter'}:
              </label>
              <Select
                isMulti={group.isMulti}
                options={formatOptions(filteredOptions[group.variable_name] || group.values)}
                value={
                  formatOptions(group.values).filter((value) =>
                    groupVars.includes(value.variableName) &&
                    (pendingFilters[value.variableName]?.includes(value.value) || value.selected)
                  )
                }
                onChange={(selectedOptions) => {
                  const selectedVariableNames = [
                    ...new Set(selectedOptions.map((option) => option.variableName))
                  ];

                  // Check for the "trans_year" condition
                  if (group.variable_name === "trans_year") {
                    if (!selectedOptions || selectedOptions.length === 0) {
                      alert("No options selected. Please make a selection.");

                      // Prevent further action if there's only one variable and it's for "trans_year"
                      if (groupVars.length === 1 && group.variable_name) return;
                    }
                  }

                  if (groupVars.length > 1) {
                    handleFilterChangeNew(selectedVariableNames, selectedOptions, group.displayName);
                  } else {
                    handleFilterChange(group.variable_name, selectedOptions, group.displayName);
                  }
                }}
                closeMenuOnSelect={!group.isMulti}
              />

            </div>
          );
        })
      )}
    </div>
  );
};

export default Filters;
